import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { ResetPasswordConstants } from 'libs/gb-dashboard/account/feature-auth/gb-forgot-password-reset/src/lib/reset-password.constants'
import { ForgotPasswordConstants } from 'libs/gb-dashboard/account/feature-auth/gb-forgot-password/src/lib/forgot-password.constants'
import { LoginConstants } from 'libs/gb-dashboard/account/feature-auth/login/src/lib/login.constants'
import { RegisterConstants } from 'libs/gb-dashboard/account/feature-auth/register/src/lib/register.constants'
import { ClientAccountInviteConstants } from 'libs/gb-dashboard/account/feature-auth/gb-client-account-invite/src/lib/client-account-invite.constants'
import { IsAuthenticatedGuard } from 'libs/gb-dashboard/account/utils/src'
import { PrintInvoiceConstants } from 'libs/gb-dashboard/setup/feature-print-invoice/src/lib/print-invoice.constants'
import { VerifyConstants } from 'libs/gb-dashboard/account/feature-auth/verify/src/lib/verify.constants'
import { MaintenanceConstants } from 'libs/shared/maintenance/src/lib/maintenance.constants'
import { PresenterConstants } from 'libs/gb-dashboard/presenter/feature/src/lib/presenter.constants'
import { GbPresenterTemplateComponent } from 'libs/gb-dashboard/presenter/feature/src/lib/gb-presenter-template/gb-presenter-template.component'
import { ClientAccountConstants } from 'libs/gb-dashboard/client-account/feature/src/lib/client-account.enum'

const defaultTitle = 'GalaBid Dashboard'

export const routes: Routes = [
  {
    path: LoginConstants.LOGIN,
    title: defaultTitle,
    loadChildren: () =>
      import('libs/gb-dashboard/account/feature-auth/login/src').then(
        (m) => m.GbDashboardAccountFeatureAuthLoginModule,
      ),
  },
  {
    path: RegisterConstants.REGISTER,
    title: defaultTitle,
    loadChildren: () =>
      import('libs/gb-dashboard/account/feature-auth/register/src').then(
        (m) => m.GbDashboardAccountFeatureAuthRegisterModule,
      ),
  },
  {
    path: `${ClientAccountInviteConstants.CLIENT_ACCOUNT_INVITE}/:user/:token`,
    title: defaultTitle,
    loadChildren: () =>
      import('libs/gb-dashboard/account/feature-auth/gb-client-account-invite/src').then(
        (m) => m.GbDashboardAccountFeatureAuthGbClientAccountInviteModule,
      ),
  },
  {
    path: ForgotPasswordConstants.FORGOT_PASSWORD,
    title: defaultTitle,
    loadChildren: () =>
      import('libs/gb-dashboard/account/feature-auth/gb-forgot-password/src').then(
        (m) => m.GbDashboardAccountFeatureAuthGbForgotPasswordModule,
      ),
  },
  {
    path: `${ResetPasswordConstants.RESET_PASSWORD}/:user/:token`,
    title: defaultTitle,
    loadChildren: () =>
      import('libs/gb-dashboard/account/feature-auth/gb-forgot-password-reset/src').then(
        (m) => m.GbDashboardAccountFeatureAuthGbForgotPasswordResetModule,
      ),
  },
  {
    path: PrintInvoiceConstants.PRINT_INVOICE,
    title: defaultTitle,
    canActivate: [IsAuthenticatedGuard],
    loadChildren: () =>
      import('libs/gb-dashboard/setup/feature-print-invoice/src').then(
        (m) => m.GbDashboardSetupFeaturePrintInvoiceModule,
      ),
  },
  {
    path: VerifyConstants.VERIFY,
    title: defaultTitle,
    loadChildren: () =>
      import('libs/gb-dashboard/account/feature-auth/verify/src').then((m) => m.GbDashboardAuthFeatureVerifyModule),
  },
  {
    path: `${ClientAccountConstants.CLIENT_ACCOUNT}/${ClientAccountConstants.PREFERRED_CONTACT_EMAIL_VERIFICATION}/:clientAccountUuid`,
    pathMatch: 'full',
    title: defaultTitle,
    loadComponent: () =>
      import(
        'libs/gb-dashboard/client-account/feature/src/lib/gb-preferred-contact-email-verification/gb-preferred-contact-email-verification.component'
      ).then((m) => m.GbPreferredContactEmailVerificationComponent),
  },
  {
    path: PresenterConstants.PRESENTER,
    loadChildren: () =>
      import('libs/gb-dashboard/presenter/feature/src/lib/presenter-routing.module').then(
        (m) => m.GbDashboardPresenterRoutingModule,
      ),
  },
  {
    path: PresenterConstants.PRESENTER_TEMPLATE,
    children: [
      {
        path: `:uuid`,
        component: GbPresenterTemplateComponent,
        canActivate: [IsAuthenticatedGuard],
      },
    ],
  },
  {
    path: MaintenanceConstants.UNDER_SCHEDULED_MAINTENANCE,
    loadChildren: () => import('libs/shared/maintenance/src').then((m) => m.SharedMaintenanceModule),
  },
  {
    path: '',
    canActivate: [IsAuthenticatedGuard],
    title: defaultTitle,
    loadChildren: () =>
      import('libs/gb-dashboard/core/authenticated-shell/src').then((m) => m.GbDashboardCoreAuthenticatedShellModule),
  },

  { path: '**', redirectTo: '' },
]
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
